import * as ActionTypes from '../constants/ActionTypes';

const ActionThatChangesStore = [
    //Generic action that can potentially kill a lot of boiler plate code
    //ActionTypes.LEAF_PROPERTY_CHANGE,

    ActionTypes.THEME_COLORS_SET_COLOR,
    ActionTypes.MESSAGE_COLOR,
    ActionTypes.BACKGROUND_COLOR,

    ActionTypes.THEME_BUTTONS_SET_FONT_COLOR,
    ActionTypes.THEME_BUTTONS_SET_BUTTON_SHAPE,
    ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_NORMAL,
    ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_HOVER,
    ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_DISABLED,
    ActionTypes.THEME_BUTTONS_SET_BUTTON_STYLE,
    ActionTypes.THEME_BUTTONS_SET_FONT,
    ActionTypes.THEME_BUTTONS_SET_FONT_STYLE,
    ActionTypes.THEME_BUTTONS_SET_FONT_SIZE,
    ActionTypes.THEME_BUTTONS_SET_FONT_WEIGHT,
    ActionTypes.THEME_BUTTONS_SET_TEXT_ALIGN,
    ActionTypes.THEME_BUTTONS_SET_BORDER_STYLE,
    ActionTypes.THEME_BUTTONS_SET_BORDER_WIDTH,
    ActionTypes.THEME_BUTTONS_SET_BACKGROUND_COLOR,

    ActionTypes.THEME_CARD_SET_THEME_FONT,
    ActionTypes.THEME_CARD_SET_THEME_FONT_COLOR,
    ActionTypes.THEME_CARD_SET_THEME_FONT_SIZE,
    ActionTypes.THEME_CARD_SET_THEME_FONT_WEIGHT,
    ActionTypes.THEME_CARD_SET_THEME_FONT_STYLE,
    ActionTypes.THEME_CARD_SET_THEME_TEXT_ALIGN,
    ActionTypes.THEME_CARD_SET_THEME_TEXT_DECORATION,
    ActionTypes.THEME_CARD_SET_THEME_LINE_HEIGHT,

    ActionTypes.SET_CALENDAR_THEME_VALUE,
    ActionTypes.THEME_CALENDAR_SET_THEME_FONT,
    ActionTypes.THEME_CALENDAR_SET_THEME_FONT_COLOR,
    ActionTypes.THEME_CALENDAR_SET_THEME_POPUP_COLOR,
    ActionTypes.THEME_CALENDAR_SET_THEME_POPUP_BACKGROUND,
    ActionTypes.THEME_CALENDAR_SET_THEME_FONT_SIZE,
    ActionTypes.THEME_CALENDAR_SET_THEME_FONT_WEIGHT,
    ActionTypes.THEME_CALENDAR_SET_THEME_FONT_STYLE,
    ActionTypes.THEME_CALENDAR_SET_THEME_TEXT_ALIGN,
    ActionTypes.THEME_CALENDAR_SET_THEME_TEXT_DECORATION,
    ActionTypes.THEME_CALENDAR_SET_THEME_LINE_HEIGHT,
    ActionTypes.THEME_CALENDAR_SET_DATE_SELECTED,
    ActionTypes.THEME_CALENDAR_SET_DATE_AVAILABLE,
    ActionTypes.THEME_CALENDAR_SET_DATE_UNAVAILABLE,
    ActionTypes.THEME_CALENDAR_SET_DATE_HOVER,

    ActionTypes.THEME_CALENDAR_SET_SPINNER_COLOR1,
    ActionTypes.THEME_CALENDAR_SET_SPINNER_COLOR2,

    ActionTypes.THEME_GLOBAL_SET_THEME_FONT,
    ActionTypes.THEME_GLOBAL_SET_THEME_FONT_COLOR,
    ActionTypes.THEME_GLOBAL_SET_THEME_FONT_SIZE,
    ActionTypes.THEME_GLOBAL_SET_THEME_FONT_WEIGHT,
    ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_DECORATION,
    ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_WIDTH,
    ActionTypes.THEME_GLOBAL_SET_THEME_LINE_HEIGHT,
    ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_ALIGN,
    ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_STYLE,
    ActionTypes.THEME_GLOBAL_SET_THEME_PRIMARY_BACKGROUND_COLOR,
    ActionTypes.THEME_GLOBAL_SET_THEME_SECONDARY_BACKGROUND_COLOR,

    ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT,
    ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_COLOR,
    ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_SIZE,
    ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_WEIGHT,
    ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_HOVER_COLOR,
    ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_STYLE,
    ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_DECORATION,
    ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_ALIGN,
    ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_LINE_HEIGHT,
    ActionTypes.THEME_FILTER_BAR_SET_GENERAL_BACKGROUND_COLOR,
    ActionTypes.THEME_FILTER_BAR_SET_DEFAULT_LINK_COLOR,
    ActionTypes.THEME_FILTER_BAR_SET_DEFAULT_LINK_HOVER_COLOR,

    ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_FONT_SIZE,
    ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_FONT_WEIGHT,
    ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_FONT_COLOR,
    ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_BACKGROUND_COLOR,

    ActionTypes.THEME_FORM_SET_THEME_FONT,
    ActionTypes.THEME_FORM_SET_THEME_FONT_COLOR,
    ActionTypes.THEME_FORM_SET_THEME_BORDER_RADIUS,
    ActionTypes.THEME_FORM_SET_THEME_LINE_HEIGHT,
    ActionTypes.THEME_FORM_SET_THEME_BACKGROUND_COLOR,
    ActionTypes.THEME_FORM_SET_THEME_TEXT_DECORATION,
    ActionTypes.THEME_FORM_SET_THEME_FONT_STYLE,
    ActionTypes.THEME_FORM_SET_THEME_BORDER_COLOR,
    ActionTypes.THEME_FORM_SET_THEME_FONT_SIZE,
    ActionTypes.THEME_FORM_SET_THEME_FONT_WEIGHT,

    ActionTypes.SET_BOOLEAN_VALUE_IN_CONFIG,
    ActionTypes.TOGGLE_BOOLEAN_VALUE_IN_CONFIG,
    ActionTypes.SET_TEXT_VALUE_IN_CONFIG,
    ActionTypes.SET_LIST_VALUE_IN_CONFIG,
    ActionTypes.SET_NUMBER_VALUE_IN_CONFIG,
    ActionTypes.ADD_CONFIG_ROW,
    ActionTypes.CHANGE_CONFIG_ROW,
    ActionTypes.EDIT_CONFIG_ROW,
    ActionTypes.DELETE_CONFIG_ROW,
    ActionTypes.SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
    ActionTypes.MAKE_INVISIBLE_FILTERS,
    ActionTypes.MAKE_VISIBLE_FILTERS,
    ActionTypes.SET_THIRDPARTY_DOMAINS,
    ActionTypes.UNSET_VALUE_IN_CONFIG
];

export default ActionThatChangesStore;



// WEBPACK FOOTER //
// ./src/store/ActionThatChangesStore.js